import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AdminLogin from "./components/AdminLogin";
import "../src/assets/css/style.css";
import "../src/assets/css/responsive.css";
import "../src/assets/css/bootstrap.css";
import "jquery";
import "popper.js";

import OTPverification from "./components/OTPverification";

import AdminDashBord from "./components/AdminDashBord";
import EvoOrders from "./components/EvoOrders";
import Analysts from "./components/Analysts";
import Teams from "./components/Teams";
import Parents from "./components/Parents";
import AdManagement from "./components/AdManagement";
import Permissions from "./components/Permissions";
import Application from "./components/Application";
import Details from "./components/Details";
import NewTeams from "./components/NewTeams";
import AdvancedSecuritySettings from "./components/AdvancedSecuritySettings";
import TeamShark from "./components/TeamShark";
import AnalystsCheckBox from "./components/AnalystsCheckBox";
import AnalystsIntermediate from "./components/AnalystsIntermediate";
import SwimmerLocker from "./components/SwimmerLocker";
import EditDetails from "./components/EditDetails";
import EditParentDetails from "./components/EditParentDetails";
import EditAnalystProfile from "./components/EditAnalystProfile";
import Video from "./components/Video";
import VedioDone from "./components/VedioDone";
import PageNotFound from "./components/PageNotFound";
import EditTeamInfo from "./components/EditTeamInfo";
import ProtectedRoutes from "./components/ProtectedRoutes";

import store from "./store/Store";
import { Provider } from "react-redux";

import BucketVideos from "./components/BucketVideos";
import Redirect from "./components/Redirect";
import RawVideo from "./components/RawVideo";
import ShareVideo from "./components/ShareVideo";
import AdsListing from "./components/AdsListing";
import LogsVideo from "./components/LogsVideo";
import OtpLogs from "./components/OtpLogs";
import ViewLogs from "./components/ViewLogs";
import ForgetPassword from "./components/ForgetPassword";
import VerifyYourEmail from "./components/VerifyYourEmail";
import Resetpassword from "./components/ResetPassword";
import AddNewAssistant from "./components/AddNewAssistant";
import SendVideoLink from "./components/SendVideoLink";
import Applicants from "./components/Applicants";
import SwimFAQs from "./components/FAQs";
import NewSwimFAQ from "./components/NewFAQs";
import EditSwimFAQsInfo from "./components/EditFAQs";
import PaymentHistory from "./components/PaymentHistory";
import EvoHistory from "./components/EvoHistory";
import ViewAssignApplicantProfile from "./components/ViewAssignApplicantProfile";
import EvoPackage from "./components/EvoPackage";
import EditEvoPackageDetails from "./components/EditEvoPackageDetails";
import PreviewVideo from "./components/PreviewVideo";
import Coupon from "./components/Coupon";
import EditCouponDetails from "./components/EditCouponDetails";
import MasterKey from "./components/MasterKey";
import CoachVideosPermissions from "./components/CoachVideosPermissions";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Redirect>
                <AdminLogin />
              </Redirect>
            }
          />

          <Route
            path="/oTPverification"
            element={
              <ProtectedRoutes>
                <Redirect>
                  <OTPverification />
                </Redirect>
              </ProtectedRoutes>
            }
          />

          <Route
            path="/evoOrders"
            element={
              <ProtectedRoutes>
                <EvoOrders />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/adminDashBord"
            element={
              <ProtectedRoutes>
                <AdminDashBord />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/analysts"
            element={
              <ProtectedRoutes>
                <Analysts />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/teams"
            element={
              <ProtectedRoutes>
                <Teams />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/parents"
            element={
              <ProtectedRoutes>
                <Parents />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/evo-package"
            element={
              <ProtectedRoutes>
                <EvoPackage />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/coupon-code"
            element={
              <ProtectedRoutes>
                <Coupon />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/master-key"
            element={
              <ProtectedRoutes>
                <MasterKey />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/restore-tablet-permission"
            element={
              <ProtectedRoutes>
                <CoachVideosPermissions />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/edit-evo-package-details"
            element={
              <ProtectedRoutes>
                <EditEvoPackageDetails />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/edit-coupon-details"
            element={
              <ProtectedRoutes>
                <EditCouponDetails />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/shareVideo"
            element={
              <ProtectedRoutes>
                <ShareVideo />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/adManagement"
            element={
              <ProtectedRoutes>
                <AdManagement />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/permissions"
            element={
              <ProtectedRoutes>
                <Permissions />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/application"
            element={
              <ProtectedRoutes>
                <Application />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/details/:id"
            element={
              <ProtectedRoutes>
                <Details />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/newTeams"
            element={
              <ProtectedRoutes>
                <NewTeams />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/bucketVideos"
            element={
              <ProtectedRoutes>
                <BucketVideos />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/bucketVideos/:id"
            element={
              <ProtectedRoutes>
                <BucketVideos />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/advancedSecuritySettings/:name"
            element={
              <ProtectedRoutes>
                <AdvancedSecuritySettings />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/teamShark/:id"
            element={
              <ProtectedRoutes>
                <TeamShark />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/analystsCheckBox"
            element={
              <ProtectedRoutes>
                <AnalystsCheckBox />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/applicants"
            element={
              <ProtectedRoutes>
                <Applicants />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/analystsIntermediate"
            element={
              <ProtectedRoutes>
                <AnalystsIntermediate />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/swimmerLocker"
            element={
              <ProtectedRoutes>
                <SwimmerLocker />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/editDetails"
            element={
              <ProtectedRoutes>
                <EditDetails />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/editParentDetails"
            element={
              <ProtectedRoutes>
                <EditParentDetails />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/editAnalystProfile"
            element={
              <ProtectedRoutes>
                <EditAnalystProfile />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/video"
            element={
              <ProtectedRoutes>
                <Video />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/video/:id"
            element={
              <ProtectedRoutes>
                <Video />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/vedioDone"
            element={
              <ProtectedRoutes>
                <VedioDone />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/editTeamInfo"
            element={
              <ProtectedRoutes>
                <EditTeamInfo />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/rawVideo"
            element={
              <ProtectedRoutes>
                <RawVideo />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/sendvideolink"
            element={
              <ProtectedRoutes>
                <SendVideoLink />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/adsListing"
            element={
              <ProtectedRoutes>
                <AdsListing />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/logsVideo"
            element={
              <ProtectedRoutes>
                <LogsVideo />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/preview-video"
            element={
              <ProtectedRoutes>
                <PreviewVideo />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/otpLogs/:id/:type"
            element={
              <ProtectedRoutes>
                <OtpLogs />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/viewLogs"
            element={
              <ProtectedRoutes>
                <ViewLogs />
              </ProtectedRoutes>
            }
          />
           <Route
            path="/swimfaqs"
            element={
              <ProtectedRoutes>
                <SwimFAQs />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/newswimfaqs"
            element={
              <ProtectedRoutes>
                <NewSwimFAQ />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/editswimfaqs/:id"
            element={
              <ProtectedRoutes>
                <EditSwimFAQsInfo />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/forgetPassword"
            element={
              <Redirect>
                <ForgetPassword />
              </Redirect>
            }
          />
          <Route
            path="/verifyYourEmail"
            element={
              <Redirect>
                <VerifyYourEmail />
              </Redirect>
            }
          />
          <Route
            path="/resetpassword"
            element={
              <Redirect>
                <Resetpassword />
              </Redirect>
            }
          />

          <Route
            path="/addNewAssistant"
            element={
              <ProtectedRoutes>
                <AddNewAssistant />
              </ProtectedRoutes>
            }
          />
           <Route
            path="/payment-history"
            element={
              <ProtectedRoutes>
                <PaymentHistory />
              </ProtectedRoutes>
            }
          />
           <Route
            path="/evo-history/:id"
            element={
              <ProtectedRoutes>
                <EvoHistory />
              </ProtectedRoutes>
            }
          />
           <Route
            path="/applicant-status/:id"
            element={
              <ProtectedRoutes>
                <ViewAssignApplicantProfile />
              </ProtectedRoutes>
            }
          />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
